import { Translation } from '@ps/web-shared-components';
import { isToday, isTomorrow } from 'date-fns';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';

import { TXTWCL_Today, TXTWCL_Tomorrow } from './FormattedRelativeDate.messages.json';

export interface Props {
  date: Date;
  showDayName?: boolean;
  showToday?: boolean;
  showTomorrow?: boolean;
}

const FormattedRelativeDate: React.FC<Props> = ({
  date,
  showDayName = true,
  showToday = true,
  showTomorrow = true
}) => {
  const locale = useSelector(select.locale.getIntlLocale);

  if (isToday(date) && showToday) return <Translation {...TXTWCL_Today} />;
  if (isTomorrow(date) && showTomorrow) return <Translation {...TXTWCL_Tomorrow} />;

  if (showDayName) {
    const weekday = new Intl.DateTimeFormat(locale, {
      weekday: 'long'
    }).format(date);

    return <span>{weekday}</span>;
  }

  return <SportsFormattedTimeZone date={date.toISOString()} format="medium" />;
};

export default FormattedRelativeDate;
